module.exports = __webpack_public_path__ + "62cc54230adabfc5191bf6fcdc782af1.jpg";